function setKeys(item, counter){
    item.__key = ++counter.counter;
    if(item.children){
        try{
            for(let i=0; i<item.children.length; i++){
                setKeys(item.children[i], counter);
            }
        }catch(error){
            console.warn("Normalizzatore (setKeys):", error);
        }
    }
}

export default function(arg){
    if (arg != null) {
        // Genero un oggetto risultato e inizio a costruirmelo.
        const res = new Object();
        res.uptime = arg.uptime;
        res.tipologia = "system";
        res.children = new Array();

        // Genero e aggiungo un child con tipo "general" per il risultato
        res.children.push({ 
            tipologia: "general",
            children: [
                {
                    tipologia: "general_detail",
                    uptime:arg.uptime, 
                    current_clock:arg.current_clock,
                    core_version:arg.core_version,
                    runtime_version: arg.runtime_version,
                    patch_version: arg.patch_version,
                    vnc_version: arg.vnc_version,
                    os_description: arg.os_info.description,
                    os_architecture: arg.os_info.architecture,
                    system_uptime:arg.system_uptime
                }
            ]
        });

        // Genero e aggiungo un child con tipo "temperature" per il risultato.
        const temperature_tmp = Object.assign({}, arg.temperature);
        temperature_tmp.tipologia = 'temperature_detail';
        res.children.push({tipologia:'temperature', children:[temperature_tmp]});

        //  Collettore per le informazioni sulla rete
        const network_tmp = (arg.network || []);
        network_tmp.forEach((network_item) => { 
            network_item.interface_name = network_item.name;
            delete network_item.name;
            const child = Object.assign({ tipologia : 'network_detail'}, network_item);            
            network_item.tipologia = 'network_interface'; 
            network_item.children = [child];
        });
        res.children.push({tipologia:'network', children: network_tmp});

        // Faccio un collettore di macchine da inserire, poi, nella risposta.
        const macchine_tmp = new Object();
        macchine_tmp.tipologia = "macchine";
        macchine_tmp.children = new Array();

        if(arg.configuration){
            // Genero e costruisco le macchine, alla fine del forEach le aggiungo.
            arg.configuration.machines.forEach((m) => {
                const m_tmp = new Object();
                m_tmp.machine_id = m.machine_id;
                m_tmp.machine_description = m.machine_description;
                m_tmp.tipologia = "macchina";
                m_tmp.children = new Array();

                // Per ogni interfaccia...
                m.interfaces.forEach((i) => {
                    const i_tmp = new Object();
                    i_tmp.tipologia = "interfaccia_detail";
                    for (let f in i) {
                        if (f != "settings" && f != "registers") {
                            i_tmp[f] = i[f];
                        }
                    }

                    // Genero un collettore di settings.
                    const coll_settings_interfaccia = new Object();
                    coll_settings_interfaccia.tipologia = "configurazione";
                    coll_settings_interfaccia.children = [Object.assign({_keys:Object.keys(i.settings), tipologia:'configurazione_detail'}, i.settings)];


                    // Genero un collettore di registri.
                    const registri_tmp = new Object();
                    registri_tmp.tipologia = "registri";
                    registri_tmp.children = new Array();

                    // Popolo il collettore dei registri.
                    i.registers.forEach((r) => {
                        const registro_tmp = new Object();
                        registro_tmp.tipologia = "registro";
                        registro_tmp.register_id = r.register_id;
                        registro_tmp.register_status = r.register_status;
                        registro_tmp.status_detail = r.status_detail;
                        registro_tmp.children = new Array();

                        // Genero un collettore di configurazioni
                        const configurazione_2l_tmp = new Object();
                        configurazione_2l_tmp.tipologia = "configurazione";
                        configurazione_2l_tmp.children = [Object.assign({_keys:Object.keys(r.settings), tipologia:'configurazione_detail'}, r.settings)];

                        // Aggiungo il collettore di configurazioni ai children del registro.
                        registro_tmp.children.push(configurazione_2l_tmp);

                        // Genero un collettore di variabili.
                        const variabili_tmp = new Object();
                        variabili_tmp.tipologia = "variabili";
                        variabili_tmp.children = new Array();

                        // Per ogni variabile nel registro...
                        r.variables.forEach((v) => {
                            const variabile_tmp = new Object();
                            variabile_tmp.tipologia = "variabile";
                            for (let f in v) {
                                if (f !== "settings" && f !== "alarms") {
                                    variabile_tmp[f] = v[f];
                                }
                            }
                            variabile_tmp.children = new Array();

                            // Genero un collettore di configurazioni della variabile.
                            const configurazione_3l_tmp = new Object();
                            configurazione_3l_tmp.tipologia = "configurazione";
                            configurazione_3l_tmp.children = [Object.assign({_keys:Object.keys(v.settings), tipologia:'configurazione_detail'}, v.settings)];

                            // Aggiungo il collettore di configurazioni ai children della variabile.
                            variabile_tmp.children.push(configurazione_3l_tmp);

                            // Genero un collettore di allarmi.
                            const alarms_tmp = new Object();
                            alarms_tmp.tipologia = "alarms";
                            alarms_tmp.children = new Array();
                            
                            // Popolo il collettore di allarmi.
                            v.alarms.forEach((a) => {
                                const allarme_tmp = Object.assign({}, a);
                                allarme_tmp.tipologia = "allarme";
                                alarms_tmp.children.push(allarme_tmp);
                            });
                            variabile_tmp.children.push(alarms_tmp);
                            variabili_tmp.children.push(variabile_tmp);
                        });
                        registro_tmp.children.push(variabili_tmp);
                        registri_tmp.children.push(registro_tmp);
                    });
                    m_tmp.children.push({
                        tipologia : 'interface',
                        interface_name : i_tmp.interface_name,
                        children : [i_tmp, coll_settings_interfaccia, registri_tmp]
                    });
                });
                macchine_tmp.children.push(JSON.parse(JSON.stringify(m_tmp)));
            });
        }
        
        res.children.push(macchine_tmp);
        setKeys(res,{counter:0});
        return res;
    }else{
        return null;
    }
}